import styled from 'styled-components';
import { PrimaryButton } from '../../components/Button';
import { level1Content } from '../../styles/shareableStyles';
import { theme } from '../../styles/theme';

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 24px;
  ${level1Content};
`;
export const HeaderCreateAction = styled(PrimaryButton)`
  display: inline-block;
  flex: 0 0 auto;
`;
export const TotalLabel = styled.div`
  font-size: 12px;
  color: ${theme.colors.secondary800};
`;
